import styled from 'styled-components';

import {media} from '../../styles/components/media-queries';
import {Button} from '../../styles/components/button.style';
import {padding} from '../../styles/core/padding.style';
import {Wrapper} from '../Modal/modal.style';

export const WrapperStyled = styled(Wrapper)`
  ${media.small`
    padding-bottom: 66px;
  `};
`;

export const Title = styled.h3`
  font-size: 2.4rem;
  margin: 0;
`;

export const Paragraph = styled.p`
  font-size: 1.4rem;
  line-height: 2.4rem;
  margin-bottom: ${padding.padding12};
`;

export const ButtonContainer = styled.div`
  ${media.small`
    position: fixed;
    bottom: 0;
    right: ${padding.padding12};
    left: ${padding.padding12};
    background-color: ${props => props.theme.defaultModal.backgroundColor};
  `};
`;

export const Ok = Button.extend`
  float: right;
  ${media.small`
    margin-bottom: ${padding.padding12};
    margin-top: ${padding.padding12};
    width: 100%;
  `};
`;



// WEBPACK FOOTER //
// ./components/AllergyModal/AllergyModal.style.js